module.exports = __webpack_public_path__ + "img/rec-serial-2.b5373a9.png";